import {
  enumProcessingTypeSortOption,
  ProcessingTypeSortOption,
} from '@rematter/frontend-lib-api-client';
import { atom } from 'jotai';

import { processingTypesQueryAtom } from '../_graphql/queryProcessingTypes';

import { atomFromQueryString } from '~/shared/state';

export const $searchTerm = atomFromQueryString.string('q');
export const $showInactive = atomFromQueryString.boolean('inactive', false);
export const $limit = atomFromQueryString.number('limit', 25);
export const $offset = atomFromQueryString.number('offset', 0);

export const $currentSorting = atom<ProcessingTypeSortOption[]>([
  enumProcessingTypeSortOption.NameAsc,
]);

export const $remoteProcessingTypes = processingTypesQueryAtom((get) => {
  const searchTerm = get($searchTerm);
  const showInactive = get($showInactive);
  const limit = get($limit);
  const offset = get($offset);
  const sorting = get($currentSorting);

  return {
    variables: {
      searchTerm: searchTerm || undefined,
      isActive: showInactive ? undefined : true,
      limit,
      offset,
      sorting,
    },
  };
});
